// src/reducers/changePasswordSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChangePasswordState {
  oldPassword: string;
}

const initialState: ChangePasswordState = {
  oldPassword: "",
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    setOldPassword(state, action: PayloadAction<string>) {
      state.oldPassword = action.payload;
    },
    resetOldPassword(state) {
      state.oldPassword = "";
    },
  },
});

export const { setOldPassword, resetOldPassword } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
